/**
 * Mouse-drag for horizontal carousels.
 * Touch/pen is left to native overflow so phone page scrolling stays intact.
 */
(function () {
  const SELECTORS = [
    '[data-adawat-mouse-drag]',
    '[data-reviews-track-wrap]',
    '.adawat-pdp__pairs-grid',
    '.adawat-pdp__thumbs',
    '.adawat-cart-utils__carousel',
    '[data-ts-feature-viewport]',
  ].join(',');

  const SKIP_INSIDE =
    'adawat-carousel, adawat-pill-carousel, adawat-promo-carousel, adawat-subcat-carousel, adawat-inspired-spaces, adawat-featured-looks, adawat-shoppable-video, adawat-favorites-carousel, adawat-hero-slideshow, adawat-deal-banners';

  function canScroll(el) {
    return el.scrollWidth > el.clientWidth + 2;
  }

  function bind(el) {
    if (!el || el.dataset.adawatMouseDragBound === 'true') return;
    if (el.closest(SKIP_INSIDE)) return;
    el.dataset.adawatMouseDragBound = 'true';
    el.classList.add('adawat-mouse-drag');

    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;
    let pointerId = null;

    const onMove = (event) => {
      if (!dragging || event.pointerId !== pointerId) return;
      const dx = event.clientX - startX;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) {
        moved = true;
        el.classList.add('is-dragging', 'is-grabbing');
        try {
          el.setPointerCapture?.(event.pointerId);
        } catch (_) {
          /* ignore */
        }
      }
      el.scrollLeft = startScroll - dx;
      event.preventDefault();
    };

    const onUp = (event) => {
      if (!dragging) return;
      if (pointerId != null && event.pointerId !== pointerId) return;
      const didDrag = moved;
      dragging = false;
      pointerId = null;
      el.classList.remove('is-dragging', 'is-grabbing');
      try {
        el.releasePointerCapture?.(event.pointerId);
      } catch (_) {
        /* ignore */
      }
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      if (didDrag) {
        window.setTimeout(() => {
          moved = false;
        }, 50);
      } else {
        moved = false;
      }
    };

    el.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (!canScroll(el)) return;
      if (event.target.closest('button, input, textarea, select, label')) return;

      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = el.scrollLeft;
      pointerId = event.pointerId;
      el.classList.add('is-grabbing');
      window.addEventListener('pointermove', onMove, { passive: false });
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);
    });

    el.addEventListener(
      'click',
      (event) => {
        if (!moved) return;
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      },
      true
    );
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    if (scope.nodeType === 1 && scope.matches?.(SELECTORS)) bind(scope);
    scope.querySelectorAll?.(SELECTORS).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target || document);
  });
})();
